<template>
    <div>
        <app-filepicker
            label="Siegel/Logo"
            :data-source="'deha.user.misc.certifications.' + listitemId + '.data.image'"
            :data-default="{ type: 'file' }"
            file-namespace="images/certifications/default"
            accept=".jpg,.png,.gif"
        ></app-filepicker>

        <app-text
            label="Titel"
            :data-source="'deha.user.misc.certifications.' + listitemId + '.data.name'"
            :data-default="{ type: 'raw', value: 'Ihre Auszeichnung' }"
            :data-preset="'Listpresets.certifications'"
            required
            :maxlength="255"
        ></app-text>

        <app-datepicker
            label="Ablaufdatum"
            :data-source="'deha.user.misc.certifications.' + listitemId + '.data.expires'"
        ></app-datepicker>

        <app-filepicker
            label="Datei Hochladen"
            :data-source="'deha.user.misc.certifications.' + listitemId + '.data.file'"
            accept=".pdf,.zip"
        ></app-filepicker>

        <app-checkbox
            label="Link"
            :data-source="'deha.user.misc.certifications.' + listitemId + '.data.linkActive'"
            revalidate-source="link"
        ></app-checkbox>

        <app-text
            v-show="
                getProp('deha.user.misc.certifications.' + listitemId + '.data.linkActive') == 1
            "
            :required="
                getProp('deha.user.misc.certifications.' + listitemId + '.data.linkActive') == 1
            "
            label="Titel des links"
            :data-source="'deha.user.misc.certifications.' + listitemId + '.data.linkText'"
            :data-default="{ type: 'textpicker' }"
            textpicker-namespace="misc/link"
            :maxlength="255"
            revalidate-source="link"
            revalidate-target="link"
        ></app-text>

        <app-text
            v-show="
                getProp('deha.user.misc.certifications.' + listitemId + '.data.linkActive') == 1
            "
            :required="
                getProp('deha.user.misc.certifications.' + listitemId + '.data.linkActive') == 1
            "
            label="Link zur Website"
            :data-source="'deha.user.misc.certifications.' + listitemId + '.data.link'"
            pattern="^(https?:\/\/(www\.)?)?[\-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([\-a-zA-Z0-9@:%_\+.~#?\&\/\/=]*)$"
            autoformat="url"
            :maxlength="255"
            revalidate-source="link"
            revalidate-target="link"
        ></app-text>

        <app-checkbox
            label="Vorschau im Header"
            :data-source="'deha.user.misc.certifications.' + listitemId + '.data.headerPreview'"
        ></app-checkbox>

        <app-checkbox
            label="Vorschau im Footer"
            :data-source="'deha.user.misc.certifications.' + listitemId + '.data.footerPreview'"
        ></app-checkbox>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Text from '@/components/fields/simple/Text.vue';
import Datepicker from '@/components/fields/simple/Datepicker.vue';
import Filepicker from '@/components/fields/complex/Filepicker.vue';
import Checkbox from '@/components/fields/simple/Checkbox.vue';

export default {
    data() {
        return {};
    },
    methods: {},
    computed: {
        ...mapGetters(['generateMediaUrl', 'getProp', 'getListItems'])
    },
    mounted() {
        this.$emit('controlhead', {
            title: this.$helpers.uiText('R065'),
            help: this.$helpers.uiText('R066'),
            removeText: this.$helpers.uiText('R067')
        });
    },
    props: {
        moduleId: String,
        listitemId: String
    },
    components: {
        'app-text': Text,
        'app-datepicker': Datepicker,
        'app-filepicker': Filepicker,
        'app-checkbox': Checkbox
    }
};
</script>
